import { Edge } from "~/lib/pipeline/graph/Edge";

export class AdjacencyMap {
  private map: Map<string, Set<string>>;

  constructor(edges: Map<string, Edge>) {
    this.map = new Map<string, Set<string>>();

    for (const edge of edges.values()) {
      this.add(edge.source, edge.target);
    }
  }

  add(sourceId: string, targetId: string) {
    if (!this.map.has(sourceId)) {
      this.map.set(sourceId, new Set());
    }
    this.map.get(sourceId)?.add(targetId);
  }

  delete(sourceId: string, targetId: string) {
    if (!this.map.has(sourceId)) {
      return;
    }
    this.map.get(sourceId)?.delete(targetId);
  }

  getNeighbors(sourceId: string): Set<string> {
    return this.map.get(sourceId) || new Set();
  }

  /**
   * Check if a path exists between `from` and `to`.
   */
  reachable(from: string, to: string): boolean {
    const visited = new Set<string>();
    const stack = [from];

    while (stack.length > 0) {
      const current = stack.pop()!;

      if (current === to) {
        return true;
      }
      if (visited.has(current)) {
        continue;
      }

      visited.add(current);

      const neighbors = this.getNeighbors(current);
      for (const neighbor of neighbors) {
        if (!visited.has(neighbor)) {
          stack.push(neighbor);
        }
      }
    }

    return false;
  }
}
